import { Link } from "react-router-dom";
import { formatCount, getCategoryById, getHotVideos } from "@/utils/video";

export default function HotRanking() {
  const hot = getHotVideos(6);

  return (
    <aside className="lg:sticky lg:top-24">
      <div className="rounded-lg border border-background-200 bg-background-50 p-5">
        <div className="mb-5 flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-100 text-lg text-accent-600">
            <i className="ri-fire-line" />
          </span>
          <div>
            <h2 className="font-heading text-lg font-bold text-foreground-950">热门视频榜单</h2>
            <p className="text-xs text-foreground-500">按播放量实时排序</p>
          </div>
        </div>

        <ul className="flex flex-col">
          {hot.map((v, i) => {
            const category = getCategoryById(v.category);
            return (
              <li key={v.id}>
                <Link
                  to={`/detail/${v.id}`}
                  className="group flex items-center gap-3 rounded-md p-2 transition-colors hover:bg-background-100"
                >
                  <span
                    className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                      i < 3
                        ? "bg-primary-500 text-background-50"
                        : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    {i + 1}
                  </span>
                  <img
                    src={v.cover}
                    alt={v.title}
                    title={`${v.title} - 糖心Vlog`}
                    className="h-12 w-20 shrink-0 rounded-md object-cover object-top"
                  />
                  <div className="min-w-0 flex-1">
                    <p className="line-clamp-2 text-sm font-medium leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
                      {v.title}
                    </p>
                    <p className="mt-1 flex items-center gap-3 text-xs text-foreground-500">
                      <span className="flex items-center gap-1">
                        <i className="ri-play-circle-line" /> {formatCount(v.views)}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-heart-line" /> {formatCount(v.likes)}
                      </span>
                    </p>
                  </div>
                  <span className="hidden shrink-0 rounded-full bg-secondary-100 px-2 py-0.5 text-[10px] text-secondary-900 xl:inline">
                    {category?.shortName}
                  </span>
                </Link>
              </li>
            );
          })}
        </ul>
      </div>

      <Link
        to="/special/city-walk"
        className="mt-5 flex items-center justify-between gap-3 rounded-lg bg-primary-500 p-5 text-background-50 transition-colors hover:bg-primary-600"
      >
        <div>
          <p className="font-heading text-base font-bold">本周精选专题</p>
          <p className="mt-1 text-xs text-background-100/90">城市漫游计划 · 6 个视频</p>
        </div>
        <i className="ri-arrow-right-line text-2xl" />
      </Link>
    </aside>
  );
}